<template>
  <div class="tanchuang">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="handleClose()">核算</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="300"
      :data="tableData"
    >
      <vxe-table-column field="branchCode" min-width="300" title="运单号" />
      <vxe-table-column field="loadQuantity" min-width="150" title="装车重量" />
      <vxe-table-column
        field="unloadQuantity"
        min-width="150"
        title="卸车重量"
      />
      <vxe-table-column field="author" min-width="150" title="路耗" />
      <vxe-table-column
        field="author"
        min-width="150"
        title="实际承运人实际运费"
      />
      <vxe-table-column
        field="deliveryCashFee"
        min-width="150"
        title="实收现金"
      />
      <vxe-table-column field="author" min-width="150" title="油气卡" />
      <vxe-table-column field="author" min-width="150" title="预付现金" />
      <vxe-table-column field="author" min-width="150" title="预付油卡" />
      <vxe-table-column field="author" min-width="150" title="预付加油" />
      <vxe-table-column field="author" min-width="150" title="其他费用" />
      <vxe-table-column field="author" min-width="150" title="异常费用" />
      <vxe-table-column field="author" min-width="150" title="成交单价" />
      <vxe-table-column field="author" min-width="150" title="货物单价" />
      <vxe-table-column field="author" min-width="150" title="允许亏吨" />
      <vxe-table-column field="author" min-width="150" title="公里数" />
      <vxe-table-column field="author" min-width="150" title="车牌号" />
      <vxe-table-column field="driverName" min-width="150" title="实际承运人" />
      <vxe-table-column
        field="driverPhone"
        min-width="150"
        title="实际承运人手机号"
      />
      <vxe-table-column field="author" min-width="150" title="结算方式" />
      <vxe-table-column field="author" min-width="150" title="压车时间" />
      <vxe-table-column field="author" min-width="150" title="压车地址" />
      <vxe-table-column field="author" min-width="150" title="装卸车回单" />
      <vxe-table-column field="author" min-width="150" title="装位置" />
      <vxe-table-column field="author" min-width="150" title="卸车位置" />
      <vxe-table-column
        field="author"
        min-width="150"
        title="要扣的托运人金额"
      />
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <vxe-button type="text" @click="modifyClick(scope.row)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <span>确定提交核算信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <vxe-modal
      v-model="details"
      title="修改核算"
      width="1000"
      height="520"
      resize
    >
      <accounting ref="detailRef" @event3="receive3" />
    </vxe-modal>
  </div>
</template>
<script>
import { calculateOrderDetailPC, orderHandle } from "@/api/transport";
import accounting from "./details.vue";
export default {
  name: "Tanchuang",
  components: {
    accounting
  },
  data() {
    return {
      details: false,
      dialogVisible: false,
      orderDetailDTOList: "",
      tableData: []
    };
  },
  methods: {
    Getdetails(c) {
      this.orderDetailDTOList = c;
      calculateOrderDetailPC(this.orderDetailDTOList).then(response => {
        this.tableData = response.data;
      });
    },
    modifyClick(r) {
      this.$refs.detailRef.shipmentlist(r);
      this.details = true;
    },
    // 用车类型子组件向父组件传值
    receive3(data) {
      this.details = false;
      this.tableData = data;
    },
    handleClose() {
      this.$confirm("确定提交核算吗？")
        .then(_ => {
          const rLoading = this.openLoading();
          orderHandle(this.tableData).then(response => {
            rLoading.close();
            this.$message({
              message: response.data,
              type: "success"
            });
          });
        })
        .catch(_ => {});
    }
  }
};
</script>
<style></style>
